export enum ESolarPlantViewType {
  HOURLY = "HOURLY",
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
  YEARLY = "YEARLY",
  MINUTELY = "MINUTELY",
  LAST_HOUR = "LAST_HOUR",
  LAST_THREE_HOURS = "LAST_THREE_HOURS",
  LAST_SIX_HOURS = "LAST_SIX_HOURS",
  LAST_TWELVE_HOURS = "LAST_TWELVE_HOURS",
  LAST_TWENTY_FOUR_HOURS = "LAST_TWENTY_FOUR_HOURS",
  TODAY = "TODAY",
  YESTERDAY = "YESTERDAY",
  DAY_BEFORE = "DAY_BEFORE",
  THIS_WEEK = "THIS_WEEK",
  PREVIOUS_WEEK = "PREVIOUS_WEEK",
  THIS_MONTH = "THIS_MONTH",
  PREVIOUS_MONTH = "PREVIOUS_MONTH",
  THIS_YEAR = "THIS_YEAR",
  LAST_YEAR = "LAST_YEAR",
  THIS_DAY_LAST_WEEK = "THIS_DAY_LAST_WEEK",
  LAST_TWO_DAYS = "LAST_TWO_DAYS",
  LAST_SEVEN_DAYS = "LAST_SEVEN_DAYS",
  LAST_THIRTY_DAYS = "LAST_THIRTY_DAYS",
  LAST_NINETY_DAYS = "LAST_NINETY_DAYS",
  LAST_SIX_MONTHS = "LAST_SIX_MONTHS",
  LAST_TWELVE_MONTHS = "LAST_TWELVE_MONTHS",
}
